import React, { useCallback, useEffect, useState } from "react";
import Table from "../../../Table";
import { DeleteVendor, getVendors } from "../../../../redux/vendors/action";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoData from "../../../noData";
import useInfiniteScroll from "../../../Hooks/useInfiniteScroll";
import Modal from "../../../modal";

const VendorTable = ({ openEditModal, searchValue }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [loading, setLoading] = useState(false);

  const openDeleteModal = (id) => {
    setSelectedVendorId(id);
    setIsOpenDelete(true);
  };
  const closeDeleteModal = () => {
    setIsOpenDelete(false);
    setSelectedVendorId(null);
  };

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });
  const [hasMoreData, setHasMoreData] = useState(true);

  const tableData = useSelector((state) => state?.Vendors?.getVendors?.data);

  const tableHeading = {
    no: <div className="ml-2 text-center">No.</div>,
    name: <div className=" px-2">Name</div>,
    address: <div className="px-2">Address</div>,
    pendingAmount: <div className="text-center">Pending Amount</div>,
    stores: <div className="px-2 text-left">Stores</div>,
    editDetail: <div className="mr-2 text-center"></div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = tableData?.map((e, index) => {
    return {
      no: <div className="ml-2 text-center">{index + 1}</div>,
      name: <div className=" px-2">{e?.name}</div>,
      address: <div className="px-2">{e?.address}</div>,
      pendingAmount: <div className="text-center">{e?.pendingamount}</div>,
      stores: (
        <div className="px-2 text-left">
          {e?.stores?.map((e) => e?.store?.name).join(", ")}
        </div>
      ),
      editDetail: (
        <div className="mr-2  flex justify-center gap-5">
          <img
            onClick={() => openEditModal(e)}
            className="cursor-pointer"
            src="/images/pencilIcon.svg"
            alt=""
          />
          <img
            onClick={() => openDeleteModal(e._id)}
            className="cursor-pointer"
            src="/images/deleteIcon.svg"
            alt=""
          />
        </div>
      ),
    };
  });

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  const handleDelete = async () => {
    if (selectedVendorId) {
      setLoading(true);
      await dispatch(DeleteVendor(selectedVendorId)).then((res) => {
        if (res?.status === 200) {
          dispatch(
            getVendors({
              page: filter?.page,
              limit: filter?.limit,
              search: searchValue,
            })
          );
          setLoading(false);
        }
        if (res?.data?.status === 401) {
          setLoading(false);
          navigate("/");
        }
        setLoading(false);
        closeDeleteModal();
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(
      getVendors({
        page: filter?.page,
        limit: filter?.limit,
        search: searchValue,
      })
    ).then((res) => {
      if (res?.data?.status === 401) {
        navigate("/");
      }
      if (res?.data?.data?.length === 0) {
        setHasMoreData(false);
      }
    });
  }, [dispatch, navigate, filter, searchValue]);

  return (
    <>
      {tableData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}

      <Modal
        loading={loading}
        modalWidth="w-1/3"
        isOpen={isOpenDelete}
        setIsOpen={setIsOpenDelete}
        openModal={openDeleteModal}
        closeModal={closeDeleteModal}
        imgSrc="/images/exclamationIcon.svg"
        title="Are You Sure?"
        btn1="Cancel"
        btn2="Delete"
        btnClass={"justify-end"}
        modalContent={
          <p className="text-lg font-medium">
            Deleting will permanently remove this Detail the system.
          </p>
        }
        handleBtn2={handleDelete}
      />
    </>
  );
};

export default VendorTable;
